console.log('DEALEASY SCRIPT CHARGÉ');
(function () {
  var API_URL = 'https://encore-pronto.myshopify.com/api/2026-07/graphql.json';
  var STOREFRONT_TOKEN = 'e120a996ddc542acf16fc4efed232fd3';
  var QUERY = '\n query offersMetaobjects($cursor: String) {\n metaobjects(type: "$app:dealeasy-vds", first: 250, after: $cursor) {\n nodes {\n field(key: "discount") {\n value\n } \n }\n pageInfo { endCursor hasNextPage }\n }\n }\n ';

  function fetchAllDiscounts(cursor, acc) {
    acc = acc || [];
    return fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: QUERY, variables: { cursor: cursor || null } })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var nodes = (json.data && json.data.metaobjects && json.data.metaobjects.nodes) || [];
        nodes.forEach(function (node) {
          if (node.field && node.field.value) {
            try { acc.push(JSON.parse(node.field.value)); } catch (e) {}
          }
        });
        var pageInfo = json.data && json.data.metaobjects && json.data.metaobjects.pageInfo;
        if (pageInfo && pageInfo.hasNextPage) {
          return fetchAllDiscounts(pageInfo.endCursor, acc);
        }
        return acc;
      });
  }

  function buildBadgeMap(discounts) {
  var map = {};
  discounts.forEach(function (discount) {
    if (discount.status !== 'ACTIVE') return;
    if (!discount.metafields || !discount.metafields.length) return;

    var configField = discount.metafields.find(function (m) {
      return m.namespace === 'lb-dealeasy-discount' && m.key === 'lb-dealeasy-config';
    });
    if (!configField) return;

    var config;
    try {
      config = JSON.parse(configField.value);
    } catch (e) {
      return;
    }

    if (!config.tiers || !config.tiers.length) return;
    var tier = config.tiers[0];
    var unit = config.type === 'PERCENTAGE' ? '%' : '€';
    var text = '-' + tier.value + unit + ' dès ' + tier.quantity + ' achetés';

    (config.selectedProductIds || []).forEach(function (gid) {
      var id = gid.split('/').pop();
      if (!map[id]) map[id] = text;
    });
  });
  return map;
}

  function applyBadges(map) {
    document.querySelectorAll('[data-product-id]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (map[id]) {
        var badge = card.querySelector('[data-dealeasy-badge]');
        var badgeText = card.querySelector('[data-dealeasy-badge-text]');
        if (badge && badgeText) {
          badgeText.textContent = map[id];
          badge.style.display = '';
        }
      }
    });
  }

  function init() {
    console.log('DEALEASY: init() démarre');
    fetchAllDiscounts()
      .then(function (discounts) {
        console.log('DEALEASY: discounts reçus', discounts);
        return buildBadgeMap(discounts);
      })
      .then(function (map) {
        console.log('DEALEASY: map construite', map);
        applyBadges(map);
      })
      .catch(function (e) {
        console.error('DEALEASY: ERREUR', e);
      });
  }

  console.log('DEALEASY: readyState =', document.readyState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();